/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdStarbases200Ok
 */
export interface GetCorporationsCorporationIdStarbases200Ok {
    /**
     * The moon this starbase (POS) is anchored on, unanchored POSes do not have this information
     * @type {number}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    moonId?: number;
    /**
     * When the POS onlined, for starbases (POSes) in online state
     * @type {Date}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    onlinedSince?: Date;
    /**
     * When the POS will be out of reinforcement, for starbases (POSes) in reinforced state
     * @type {Date}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    reinforcedUntil?: Date;
    /**
     * Unique ID for this starbase (POS)
     * @type {number}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    starbaseId: number;
    /**
     * state string
     * @type {string}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    state?: GetCorporationsCorporationIdStarbases200OkStateEnum;
    /**
     * The solar system this starbase (POS) is in, unanchored POSes have this information
     * @type {number}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    systemId: number;
    /**
     * Starbase (POS) type
     * @type {number}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    typeId: number;
    /**
     * When the POS started unanchoring, for starbases (POSes) in unanchoring state
     * @type {Date}
     * @memberof GetCorporationsCorporationIdStarbases200Ok
     */
    unanchorAt?: Date;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdStarbases200OkStateEnum = {
    Offline: 'offline',
    Online: 'online',
    Onlining: 'onlining',
    Reinforced: 'reinforced',
    Unanchoring: 'unanchoring'
} as const;
export type GetCorporationsCorporationIdStarbases200OkStateEnum = typeof GetCorporationsCorporationIdStarbases200OkStateEnum[keyof typeof GetCorporationsCorporationIdStarbases200OkStateEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdStarbases200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdStarbases200Ok(value: object): value is GetCorporationsCorporationIdStarbases200Ok {
    if (!('starbaseId' in value) || value['starbaseId'] === undefined) return false;
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdStarbases200OkFromJSON(json: any): GetCorporationsCorporationIdStarbases200Ok {
    return GetCorporationsCorporationIdStarbases200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStarbases200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdStarbases200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'moonId': json['moon_id'] == null ? undefined : json['moon_id'],
        'onlinedSince': json['onlined_since'] == null ? undefined : (new Date(json['onlined_since'])),
        'reinforcedUntil': json['reinforced_until'] == null ? undefined : (new Date(json['reinforced_until'])),
        'starbaseId': json['starbase_id'],
        'state': json['state'] == null ? undefined : json['state'],
        'systemId': json['system_id'],
        'typeId': json['type_id'],
        'unanchorAt': json['unanchor_at'] == null ? undefined : (new Date(json['unanchor_at'])),
    };
}

export function GetCorporationsCorporationIdStarbases200OkToJSON(json: any): GetCorporationsCorporationIdStarbases200Ok {
    return GetCorporationsCorporationIdStarbases200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStarbases200OkToJSONTyped(value?: GetCorporationsCorporationIdStarbases200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'moon_id': value['moonId'],
        'onlined_since': value['onlinedSince'] == null ? undefined : ((value['onlinedSince']).toISOString()),
        'reinforced_until': value['reinforcedUntil'] == null ? undefined : ((value['reinforcedUntil']).toISOString()),
        'starbase_id': value['starbaseId'],
        'state': value['state'],
        'system_id': value['systemId'],
        'type_id': value['typeId'],
        'unanchor_at': value['unanchorAt'] == null ? undefined : ((value['unanchorAt']).toISOString()),
    };
}

